import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
import { roles } from "../../../../common/constants";
/**
 *
 * @param {any[]} clientsByStore
 * @returns {Workbook}
 */
export const exportExcel = async (
  storeVisitors,
  selectedStore,
  startDate,
  endDate,
  role
) => {
  const json = excelHelper.jsonToJson(
    [storeVisitors],
    [
      {
        name: "TOP VISITAS POR SEDE",
        props: [
          {
            inValue: "name",
            outValue: "SEDE",
          },
          {
            inValue: "phone",
            outValue: "Teléfono",
          },
          {
            inValue: "visitors",
            outValue: "Visitas",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, role, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, role, startDate, endDate) => {
  const storeName = selectedStore.label;
  if (role == roles.SUPER_ADMIN || role == roles.ADMIN) {
    return selectedStore.value == 0
      ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          "_reporte-general-visitas-por-tiendas_" +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          ".xlsx"
      : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          "_reporte-visitas-por-tiendas_" +
          storeName.toLowerCase() +
          "_" +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          ".xlsx";
  } else {
    return (
      formatHelper.toDateYYMMDD(new Date().toUTCString()) +
      "_reporte-visitas-por-tiendas_" +
      formatHelper.toDateYYMMDD(startDate._d) +
      "_" +
      formatHelper.toDateYYMMDD(endDate._d) +
      ".xlsx"
    );
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopVisitors/excel.js